import React, {useEffect, useState} from 'react';
import {
    cuadroRequerimientosCambiarAsignacionDeVacanteAAsignacionEmpleadoAPI, cuadroRequerimientosGetCursosByIdCuadroSede,
    cuadroRequerimientosGetVacantesThatCanBecomeAsignacionesDropDownAPI,
} from "../../../../../../../consumers/backendApisUrls";
import GenericModal from "../../../../../../../components/modal/GenericModal";
import {useManagePostRequest} from "../../../../../../../hooks/useManagePostRequest/useManagePostRequest";
import InputSelect from "../../../../../../../components/modalComponents/InputSelect";
import {useManageGetRequest} from "../../../../../../../hooks/useManageGetRequest/useManageGetRequest";


const AsignarPendienteToVacante = ({toggleModal, refreshPage, idCuadroSede, idEmpleado, setTipoValues}) => {
    const [selectedVacante, setSelectedVacante] = useState(null);
    const [selectedCurso, setSelectedCurso] = useState(null);
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const vacanteVolanteItem = "Vacante Volante"

    const [vacantes, setVacantes] = useState([]);
    const [cursos, setCursos] = useState([]);

    const onClose = () => {
        setTipoValues({});
        toggleModal();
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            let api = cuadroRequerimientosCambiarAsignacionDeVacanteAAsignacionEmpleadoAPI();
            let payload = getPayload();
            await executeManagePost(api, payload, successReasignarCallback, false);
        } catch (error) {
            console.error(error);
        }
    }

    const getPayload = () => {
        return {
            IdAsignacionVacante: selectedVacante?.value,
            IdEmpleado: idEmpleado,
            DescripcionCursoSeleccionado: (selectedVacante?.label === vacanteVolanteItem ? selectedCurso?.value : "")
        }
    }

    const successReasignarCallback = () => {
        toggleModal();
        refreshPage();
        setTipoValues({});
    }

    const init = async () => {
        getVacantes();
        getCursos();
    }

    const getCursos = async () => {
        await executeManageGet(
            cuadroRequerimientosGetCursosByIdCuadroSede(idCuadroSede),
            successGetCursosCallback,
            false
        );
    }

    const successGetCursosCallback = ({data}) => {
        let items = Array.isArray(data) ? data : []
        items = items.map((item)=> ({"value": item?.Descripcion, "label": item?.Descripcion}))
        setCursos(items)
    }

    const getVacantes = async () => {
        const api = cuadroRequerimientosGetVacantesThatCanBecomeAsignacionesDropDownAPI();
        const payload = {
            IdEmpleado: idEmpleado,
            IdCuadroSede: idCuadroSede
        }
        await executeManagePost(api, payload, successManageSearchCallback);
    }

    const successManageSearchCallback = ({data}) => {
        setVacantes(data)
    }

    useEffect(()=>{
        init()
    },[])



    const handleVacanteChange = (e) => {
        const value = e.target.value;
        setSelectedVacante(value);
    };

    const handleCursoChange = (e) => {
        const value = e.target.value;
        setSelectedCurso(value);
    };

  return (
    <GenericModal showModal={onClose} titulo="Asignar a Vacante" width="600px">
        <div className="modal-body">
            <form>
                <div className="form-row">
                    <div className="form-group col-sm-12">
                        <InputSelect
                            label="Vacante"
                            name="IdAsignacionVacante"
                            options={vacantes}
                            value = {selectedVacante}
                            onChange={handleVacanteChange}
                            sectionName={"Asignar Pendiente To Vacante"}
                            isRequired={true}
                            placeholder={"Seleccionar Vacante"}
                            direction="column"
                            hasValidationMessage={false}
                        />

                    </div>
                    {selectedVacante?.label === vacanteVolanteItem &&
                        <div className="form-group col-sm-12">
                            <InputSelect
                                label="Curso"
                                name="IdCurso"
                                options={cursos}
                                value = {selectedCurso}
                                onChange={handleCursoChange}
                                sectionName={"Asignar Pendiente To Vacante"}
                                isRequired={true}
                                placeholder={"Seleccionar Curso"}
                                direction="column"
                            />
                        </div>
                    }
                </div>
                <div className="modal-footer pl-0">
                    <div>
                    </div>
                    <div>
                    <button type="button" onClick={handleSubmit} className="generic-button-buscador">
                        Guardar
                    </button>
                    </div>
                </div>
            </form>
        </div>
    </GenericModal>
  )
}

export default AsignarPendienteToVacante